module.exports = function (svg) {
  removeTextNodes($(svg).find('defs'));
  return svg;
};

function removeTextNodes ($elems) {
  $elems.each(function () {
    _.each(_.clone(this.childNodes), function (node) {
      node.nodeType === 3 && node.remove();
      node.nodeName && node.nodeName.includes(':') && node.remove();
    });

    removeTextNodes($(this.childNodes));
  });
}
